'use client'

import { SwimlaneSkeleton } from '@/app/[locale]/(worlds)/components/Swimlane'
import { ViverseWorldCardSkeleton } from '@/components/ViverseWorldCardSkeleton'
import { CARD_CLASS_CONTINUE_PLAYING } from '@/constants/card'
import {
  SWIMLANE_DEFAULT_CONTENT_INSET_CLASS,
  SWIMLANE_SCROLL_BLEED_CLASS,
} from '@/constants/swimlane'
import { enableWatchHistory } from '@/lib/configs'
import { cn } from '@/lib/utils'

export default function ContinuePlayingRowSkeleton() {
  if (!enableWatchHistory()) return null

  return (
    <div data-section="continue-playing-skeleton" aria-hidden="true">
      <SwimlaneSkeleton showTitleAction className="gap-3">
        <div
          className={cn(SWIMLANE_SCROLL_BLEED_CLASS, SWIMLANE_DEFAULT_CONTENT_INSET_CLASS, 'gap-4')}
        >
          {Array.from({ length: 5 }, (_, index) => (
            <ViverseWorldCardSkeleton
              key={index}
              className={cn(CARD_CLASS_CONTINUE_PLAYING, 'last:mr-4 lg:last:mr-6')}
            />
          ))}
        </div>
      </SwimlaneSkeleton>
    </div>
  )
}
